import script from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./StableTokenPill.vue?vue&type=style&index=0&id=418306a7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418306a7"]])

export default __exports__